import React from "react";
import { ZaunCircleMenuItem } from "./ZaunCircleMenuItem";
import { I18N } from "oc-I18N";

export function ZaunCircleMenuItemAusgleichGefälle(props) {
  const agt = APP.arrangement;
  const contract = () => {
    const pfosten = agt.selectedObjects.filter((e) => e.isPfosten);
    return (
      pfosten.length > 0 &&
      pfosten.some((p) => !p.isAufgeschraubt && !p.isUnechterpfosten && !p.isTorpfosten)
    );
  };
  if (!contract()) {
    return null;
  }
  const label = agt.selectedObjects[0].ausgleichGefälle
    ? I18N("Gefälle nicht ausgleichen")
    : I18N("Gefälle ausgleichen");
  return (
    <ZaunCircleMenuItem
      dataButtonKey={label}
      onClick={(event) => {
        if (!contract()) {
          return null;
        }

        const pfosten = agt.selectedObjects.filter((e) => e.isPfosten);
        pfosten.forEach((p) => {
          // p.anpassungDurchUser = true;
          p.ausgleichGefälle = !p.ausgleichGefälle;
        });
        APP.logUserAction({ action: "ausgleichGefälle" });
        APP.dirty();
      }}
    >
      <div className=""></div>
      {label}
    </ZaunCircleMenuItem>
  );
}
